import { AxiosResponse } from 'axios';

import { supabase } from '@/lib/supabase';
import { asResponse } from '@/lib/supabase-helpers';

type PersonSkillsInput = {
  skillId: string;
  willingToReview: boolean;
};

const updateAllPersonSkills = async ({
  personId,
  skills,
}: {
  personId: string;
  skills: PersonSkillsInput[];
}): Promise<AxiosResponse<null>> => {
  // Delete existing profile_skills for this person
  const { error: deleteError } = await supabase
    .from('profile_skills')
    .delete()
    .eq('profile_id', personId);

  if (deleteError) throw deleteError;

  // Insert new skills
  if (skills.length > 0) {
    const rows = skills.map((s) => ({
      profile_id: personId,
      skill_id: s.skillId,
    }));

    const { error: insertError } = await supabase
      .from('profile_skills')
      .insert(rows);

    if (insertError) throw insertError;
  }

  return asResponse(null);
};

export default {
  updateAllPersonSkills,
};
